import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Brand } from '../../../business-entities/brand.model';
import { RentalCarService } from '../../../business-services/rental-car.service';
import { ImageService } from '../../../services/image.service';
import { CurrentLanguage } from '../../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { UserDataService } from '../../../../../../../src/app/DataServices/user-data.service';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { VehicleType } from '../../../business-entities/vehicle-list-view-model'
import { Constant } from '../../../../../../Autofacets-Core/src/app/utils/constant';
import { CheckListBusinessService } from '../../../business-services/check-list.service';
import { BaseService } from '../../../../../../Autofacets-Core/src/app/services/base.service';
import { CategoryModel, EditCategory } from '../../../business-entities/category-list-model';
import { CategoryService } from '../../../business-services/category.service';
@Component({
  selector: 'app-edit-category',
  templateUrl: './edit-category.component.html',
})
export class EditCategoryComponent implements OnInit {

  AnswerList = Array(1);
  editCategory = false;
  editCategoryForm: FormGroup;
  brandList: Brand[] = [];
  brand: Brand[];
  id: number;
  language: string;
  image: string | ArrayBuffer;
  CategoryModel: CategoryModel;
  editedCategory: EditCategory = {
    categoryName: "",
    categoryDescription: "",
    updatedBy: "",
    description: ""
  };

  imageBaseData: string | ArrayBuffer = null;
  allLanguage: any[];
  vehicleTypes: VehicleType[] = [];
  constructor(
    private formBuilder: FormBuilder,
    private getAllBrandData: RentalCarService,
    private categoryService: CategoryService,
    private spinner: NgxSpinnerService,
    private baseService: BaseService,
    private toastr: ToastrService,
    private router: Router,
    private translate: TranslateService,
    private currentLanguageService: CurrentLanguage,
    private cdr: ChangeDetectorRef,
    private activeModal: NgbActiveModal,
    private userService: UserDataService,
    private imageService: ImageService,
    private checkListService: CheckListBusinessService
  ) { }

  ngOnInit(): void {
    this.allLanguage = this.currentLanguageService.LanguageList;
    this.editCategoryForm = this.formBuilder.group({
      categoryName: new FormArray([]),
      categoryDescription: new FormArray([]),
      //answerInputs: ['', [Validators.required]],
      isActive: ['']
    });
    this.getBrandData();
    this.getLanguage();
    this.GetAllVehicleTypes();
  }

  get t() { return this.cpf.categoryName as FormArray; }
  get c() { return this.cpf.categoryDescription as FormArray; }

  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
      for (let i = this.t.length; i < number; i++) {
        this.t.push(this.formBuilder.group({
          languageId: ['', Validators.required],
          name: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.t.removeAt(i);
      }
    }
    if (this.c.length < number) {
      for (let i = this.c.length; i < number; i++) {
        this.c.push(this.formBuilder.group({
          languageId: ['', Validators.required],
          description: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.c.length; i >= number; i--) {
        this.c.removeAt(i);
      }
    }
  }

  async GetAllVehicleTypes(): Promise<void> {
    await this.checkListService.getVehicleTypes().then(data => {
      if (localStorage.getItem("Theme") == Constant.BnhInterface) {
        this.vehicleTypes = data.responseObject;
      }
      else {
        this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
      }
    });
  }
  async getBrandData() {
    this.id = this.categoryService.categoryId
    await this.GetAllBrand();
    this.currentLanguageService.currentLanguage.subscribe(x => {
      this.language = x
      this.getCategory(this.id);
    });
  }
  get cpf() {
    return this.editCategoryForm.controls;
  }

  async GetAllBrand() {
    await this.getAllBrandData.GetAllBrand().then(data => {
      this.brand = data.responseObject;
      for (let value of this.brand) {
        this.brandList.push(value)
      }
    })
  }

  async getCategory(id: number) {
    this.spinner.show();
    await this.categoryService.getCategoryById(id).then(result => {
      if (result) {
        this.CategoryModel = result.responseObject;
        this.editCategoryForm.patchValue({
          ...result.responseObject,
        })
      }
    })
    this.spinner.hide();
  }

  editCategorys() {
    this.spinner.show();
    let currentUser = this.userService.currentUserValue.id;
    const viewModel = {
      ...this.editCategoryForm.value,
      updatedBy: currentUser,
      id: this.CategoryModel.categoryDetails.id
    }

    this.categoryService.addEditCategory(viewModel).then(res => {
      if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
        let successmsg = this.translate.instant("lblCategoryUpdated");
        this.toastr.success(successmsg);
        this.spinner.hide();
        this.activeModal.close({ success: true });
      }
      else if (res.responseObject === false) {
        this.spinner.hide();
        let errormsg = this.translate.instant("lblCategoryExist");
        this.toastr.warning(errormsg);
      }
    });
    this.spinner.hide();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  OnClose() {
    this.activeModal.close({success:false})
  }

}
